/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

const MIN_MAX_AGE: number = 5 * 1000;

const RESOURCE_TYPE_DASHBOARDS_DIRECTORY = 'DASHBOARDS_DIRECTORY';
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const dashboardsDirectoryResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_DASHBOARDS_DIRECTORY,
	getKey: () => 'state',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-dashboards-directory", jiraSpaEntry: "async-resource-dashboards-directory" */ './getData.tsx'
		),
	maxAge: MIN_MAX_AGE,
});
